import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PortfolioPassportEditPage from './PassportEdit/Page';
import PortfolioProfilePage from './Profile/Page';
import { getMngData, getPeriodsData, _default } from './PassportEdit/helpers/passport';
import useAPI from '../../hooks/useAPI';

export default function PortfolioIndexRouter() {
  const api = useAPI();

  const { stratId, portfolioId } = useParams();

  if (portfolioId === 'new') return (<PortfolioPassportEditPage />);

  return (
    <PortfolioProfilePage
      stratId={stratId}
      portfolioId={portfolioId}
    />
  );
}
